import isNil from 'lodash/isNil';

function checkLimit(limit, equal, num, upper) {
  if (num === limit) return equal;
  if (upper) {
    if (num > limit) return false;
  } else {
    if (num < limit) return false;
  }
  return true;
}

export function checkNumber(value, { min, max, equal = {}, precision = -1 }) {
  if (isNil(value) || value === '') return false;
  const num = Number(value);
  if (window.isNaN(num)) return false;
  if (!isNil(max) && !checkLimit(max, equal.max, num, true)) {
    return false;
  }
  if (!isNil(min) && !checkLimit(min, equal.min, num)) {
    return false;
  }
  if (precision >= 0) {
    const base = Math.pow(10, precision);
    var round = Math.round(num * base) / base;
    if (round !== num) return false;
  }
  return true;
}

/** 按照移动端 vant 定义的校验规则 */
export function number(opts) {
  const { min, max, required = true, equal = {}, precision = -1 } = opts;
  let msgs = ['请输入'];
  if (!isNil(min)) {
    msgs.push('大于');
    if (equal.min) msgs.push('等于');
    msgs.push(min);
  }
  if (!isNil(max)) {
    msgs.push('小于');
    if (equal.max) msgs.push('等于');
    msgs.push(max);
  }
  if (!isNil(min) || !isNil(max)) {
    msgs.push('的');
  }
  if (precision !== -1) {
    if (precision === 0) {
      msgs.push('整数');
    } else {
      msgs.push(`数字，最多保留${precision}位小数`);
    }
  } else {
    msgs.push('数字');
  }
  const message = msgs.join('');
  return {
    required,
    message,
    validator(rule, value, callback) {
      if (checkNumber(value, opts)) {
        return callback();
      }
      callback(new Error(message));
    },
    trigger: 'change'
  };
}

export function convertRule(raw) {
  return {
    required: isNil(raw.required) ? true : raw.required,
    validator(rule, value, callback) {
      if (!raw.validator) {
        callback();
        return;
      }
      if (raw.validator(value)) {
        callback();
      } else {
        let message;
        if (typeof raw.message === 'function') {
          message = raw.message(value);
        } else {
          message = raw.message;
        }
        callback(new Error(message));
      }
    },
    trigger: 'change'
  };
}
